import type { ItemStatus } from "./items";

export enum SupportedAuthenticationMethod {
  ALL = "all",
  PASSWORD = "password",
  SSO = "sso",
}

export interface Client {
  id: number;
  name: string;
  logo?: string;
  slug?: string;
  color?: string;
  address?: string;
  contactEmail?: string;
  website?: string;
  size?: number;
  department?: string;
  fields?: Record<string, unknown>;
  createdAt: Date;
  updatedAt: Date;
  supportedAuthenticationMethods?: SupportedAuthenticationMethod;
  allowedRoutes?: string[];
  visibleColumns?: Record<string, string[]>;
  dateFormat?: string;
  timeFormat?: string;
  allowedStatuses?: ItemStatus[];
}

export type CreateClientPayload = Omit<
  Client,
  "id" | "createdAt" | "updatedAt"
>;
